module.exports = __webpack_public_path__ + "img/contact.03301a2b.png";